export default "__VITE_ASSET__AqxUJ9uI__"